(() => {
  const route = link => {
    if (!link.matches('a[href]')) return;
    if (link.hasAttribute('data-ss-preset')) return;
    const url = new URL(link.href, location.origin);
    if (url.origin !== location.origin) return;
    const path = url.pathname.replace(/\/$/, '');
    const bestView = url.searchParams.get('view') === 'ss-bestsellers';
    const bestHandle = /^\/collections\/(best-sellers|best-seller-apparel)$/.test(path);
    const bestLabel = /best\s*seller/i.test(link.textContent+' '+(link.title||''));
    const bestSort = url.searchParams.get('sort_by') === 'best-selling' && bestLabel;
    if (bestView || bestHandle || (bestSort && /^\/collections\/(shop-by-translation|apparel)$/.test(path))) {
      if (link.closest('.ss-bestsellers')) return;
      const apparel = /\/collections\/(apparel|best-seller-apparel)(?:\/|$)/.test(path);
      url.pathname = apparel ? '/collections/apparel/bestseller' : '/collections/shop-by-translation/bestseller';
      url.searchParams.set('view','ss-bestsellers');
      if (!url.searchParams.has('sort_by')) url.searchParams.set('sort_by','best-selling');
      if (!link.closest('.ss-bestsellers')) {
        link.removeAttribute('data-ss-collection-link');
        link.removeAttribute('data-ss-browse-chip');
      }
      link.href = url.href;
      return;
    }
    // Apparel categories are tag presets on the same collection and template.
    const apparelTags = { 't-shirt':'tshirt', tees:'tshirt', hoodie:'hoodie', hoodies:'hoodie', crewneck:'crewneck', 'best-seller-apparel':'' };
    const handle = url.pathname.replace(/\/$/, '').split('/').pop();
    if ((/^\/collections\/[^/]+\/?$/.test(url.pathname) && Object.prototype.hasOwnProperty.call(apparelTags, handle)) || /^\/collections\/apparel(?:\/(?:new|tshirt|hoodie|crewneck))?\/?$/.test(url.pathname)) {
      const tag = apparelTags[handle];
      if (tag !== undefined) url.pathname = '/collections/apparel' + (tag ? '/' + tag : '');
      url.searchParams.delete('view');
      if (handle === 'new' || !url.searchParams.has('sort_by')) url.searchParams.set('sort_by','best-selling');
      link.removeAttribute('data-ss-collection-link');
      link.removeAttribute('data-ss-browse-chip');
      link.href = url.href;
      return;
    }
    if (url.searchParams.has('view')) return;
    const sortedBest = url.searchParams.get('sort_by') === 'best-selling' && /\/collections\/(shop-by-translation|apparel)$/.test(path);
    const saleCollection = /\/collections\/(sale|apparel\/sale)$/.test(path);
    const newCollection = /\/collections\/(new|apparel\/new)$/.test(path);
    const bestCollection = /\/collections\/(best-sellers|best-seller-apparel)$/.test(path);
    if (!saleCollection && !newCollection && !bestCollection && !(sortedBest && /best\s*seller/i.test(link.textContent+' '+(link.title||'')))) return;
    // Open dedicated views from regular collections instead of their in-page controller.
    if(link.closest('.ss-bestsellers')) return;
    link.removeAttribute('data-ss-collection-link');
    link.removeAttribute('data-ss-browse-chip');
    url.searchParams.set('view', saleCollection ? 'ss-sale' : newCollection ? 'ss-new' : 'ss-bestsellers');
    if (newCollection) url.searchParams.set('sort_by','created-descending');
    link.href = url.href;
  };
  const scan = root => { if(root instanceof Element) route(root); root.querySelectorAll?.('a[href]').forEach(route); };
  scan(document);
  new MutationObserver(records => records.forEach(record => record.addedNodes.forEach(scan))).observe(document.documentElement,{childList:true,subtree:true});
})();



